<template>
  <div class="row">
    <div class="col">
      <DataTable
          class="p-datatable-sm"
          :value="tableValeurs"
          :resizableColumns="true"
          columnResizeMode="fit"
          :reorderableColumns="true"
          dataKey="cleTV"
          :paginator="true"
          :rows="10"
          sort-field="tv"
          :sortOrder="-1"
          selectionMode="single"
          @row-select="onRowSelect"
          paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
          :rowsPerPageOptions="[10, 30, 100]"
          currentPageReportTemplate="Afficher {first} de {last} sur {totalRecords} provinces"
      >
        <template #empty>
          <div v-if="isRechercheDataLoading == true" class="row">
            <div class="col">
              <vue-loaders name="ball-beat" class="justify-center"></vue-loaders>
            </div>
          </div>
          <div v-else class="row">
            &nbsp;&nbsp;&nbsp;Aucun enregistrement retourné
          </div>
        </template>
        <Column
            field="cleTV"
            header="Clé TV"
            :sortable="true"
        ></Column>
        <Column
            field="description"
            header="Libellé"
            :sortable="true"
        ></Column>
        <Column
            field="abreviation"
            header="abreviation"
            :sortable="true"
        ></Column>
        <Column
            field="aide"
            header="aide"
            :sortable="true"
        ></Column>


        <Column headerStyle="width: 8rem" :exportable="false">
          <template #body="slotProps">
            <div class="row">
              <div class="col">
                <Button
                    icon="pi pi-save"
                    class="p-button-datatable p-button-rounded-sm"
                    @click="sauvegarder(slotProps.data)"
                />
              </div>
              <div class="col">
                <Button
                    icon="pi pi-trash"
                    class="p-button-datatable p-button-rounded-sm"
                    @click="confirmerSuppression(slotProps.data)"
                />
              </div>
            </div>
          </template>
        </Column>
      </DataTable>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import axios from 'axios';


export default {
  props: ['tableValeurs', 'isRechercheDataLoading'],
  components: {
  },
  computed: {
    ...mapGetters({
      jeton: "cardex/jeton",
      profil: 'cardex/profil',
    }),
  },
  mounted() {
    axios.defaults.headers.common['cleProfil'] = this.profil.cle;
  },
  methods: {
    onRowSelect(event) {
      console.log(event.data)
      this.$store.commit('pilotage/TABLE_VALEUR',event.data);
      this.$router.push({
        name: "modifierTV",
        params: {
          cleTV: event.data.cleTV,
        }
      });
    },
    sauvegarder() {
    },
  }

}
</script>


<style scoped>

</style>